import axios from "axios";
import { useEffect, useState } from "react";

const AI_DOC_ENDPOINT = "https://cdn.que.zone/ai/onboarding-agent"

const QUICK_PROMPTS = [
    'Where can I see bookings of our customers',
    'Help me create a service',
    'How to add a service provider',
    'Set up a new schedule for a service'
];

export const useAiDocs = () => {
    const [systemPrompt, setSystemPrompt] = useState("");
    const [knowledgeBaseIndex, setKnowledgeBaseIndex] = useState({});
    const [knowledgeBase, setKnowledgeBase] = useState({});
    const [quickPrompts, setQuickPrompts] = useState(QUICK_PROMPTS);

    const getSystemPrompt = async (query) => {
        try {
            const { data } = await axios.get(`${AI_DOC_ENDPOINT}/system-prompt.md`);
            if (data) {
                //console.log("System prompt Fetched", data);
                setSystemPrompt(data);
            }
        } catch (error) {
            console.error('Error fetching System Prompt:', error);
        }
    }
    const getQuickPrompts = async (query) => {
        try {
            const { data } = await axios.get(`${AI_DOC_ENDPOINT}/quick-prompts.json`);
            if (data && data?.prompts?.length) {
                //console.log("System prompt Fetched", data);
                setQuickPrompts(data.prompts);
            }
        } catch (error) {
            console.error('Error fetching Quick Prompts:', error);
        }
    }

    const getKnowledgeBaseIndex = async () => {
        /* Example
       {
           "documents": [
               {
               "id": "organization",
               "title": "Organization",
               "summary": "Organization configuration, branding, holidays, preferences and booking settings.",
               "keywords": [
                   "organization",
                   "logo",
                   "branding",
                   "timezone",
                   "holiday",
                   "booking horizon",
                   "booking cutoff",
                   "whitelabel",
                   "privacy"
               ],
               "priority": 100,
               "url": "organization.md"
               }
           ]
       }
        */
        try {
            const { data } = await axios.get(`${AI_DOC_ENDPOINT}/knowledgebase/index.json`);
            if (data) {
                setKnowledgeBaseIndex(data);
            }
        } catch (error) {
            console.error('Error fetching Knowledgebase index:', error);
        }
    }

    const preloadKnowledgeBase = async () => {
        if (!knowledgeBaseIndex?.documents?.length) return;

        try {

            const docs = await Promise.all(
                knowledgeBaseIndex.documents.map(async (doc) => {
                    const { data } = await axios.get(
                        `${AI_DOC_ENDPOINT}/knowledgebase/${doc.url}`
                    );

                    return [doc.id, data];
                })
            );

            const cache = Object.fromEntries(docs);
            setKnowledgeBase(cache);
        } catch (error) {
            console.error('Error fetching knowlegebase docs:', error);
        }
    };

    const getKnowledgeDocument = (id) => {
        return knowledgeBase[id] ?? null;
    };

    const searchKnowledge = (query, maxResults = 3) => {

        if (!knowledgeBaseIndex?.documents?.length) {
            return [];
        }
        const searchText = query.toLowerCase().trim();
        const results = knowledgeBaseIndex.documents
            .map(doc => {
                let score = doc.priority || 0;
                // Match title
                if (doc.title?.toLowerCase().includes(searchText)) {
                    score += 100;
                }
                // Match summary
                if (doc.summary?.toLowerCase().includes(searchText)) {
                    score += 40;
                }
                // Match keywords
                (doc.keywords || []).forEach(keyword => {
                    const k = keyword.toLowerCase();
                    // Exact keyword match
                    if (searchText === k) {
                        score += 100;
                    }
                    // Query contains keyword
                    else if (searchText.includes(k)) {
                        score += 50;
                    }
                    // Keyword contains query
                    else if (k.includes(searchText)) {
                        score += 25;
                    }
                });
                return {
                    ...doc,
                    score
                };
            })
            .filter(doc => doc.score > 0)
            .sort((a, b) => b.score - a.score)
            .slice(0, maxResults);

        return results;
    };

    useEffect(() => {
        getSystemPrompt();
        getKnowledgeBaseIndex();
        getQuickPrompts();
    }, []);


    useEffect(() => {
        if (knowledgeBaseIndex?.documents?.length) {
            preloadKnowledgeBase();
        }
    }, [knowledgeBaseIndex]);


    return {
        systemPrompt,
        quickPrompts,
        knowledgeBaseIndex,
        knowledgeBase,
        getKnowledgeDocument,
        searchKnowledge,
    }
}